export const baseButtonStyles = {
  bgcolor: "#24582A",
  color: "#FFFAF1",
  textTransform: "none",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  height: 60,
  justifyContent: "space-between",
  px: 2,
  py: 1,
  fontSize: 20,
  display: "flex",
  alignItems: "center",
  "&:hover": {
    bgcolor: "#17371A",
  },
};
export  const selectStyle = {
    width: "100%",
    height: 56,
    padding: "16.5px 14px",
    borderRadius: 8,
    border: "1px solid #24582A",
    backgroundColor: "#D4E9CF",
    color: "#052812",
    fontFamily:
        '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    fontSize: 16,
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    boxSizing: "border-box",

    accentColor: "#24582A",
};
export const buttonPrimaryStyles = {
  border: "1px solid #17371A",
  bgcolor: "#24582A",
  color: "#FFFAF1",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  borderRadius: 2,
  px: 3,
  py: 1.5,
  fontWeight: 600,
  boxShadow: 3,
  "&:hover": {
    bgcolor: "#17371A",
  },
};

export const buttonSecondaryStyles = {
  border: "1px solid #24582A",
  borderRadius: 2,
  textTransform: "none",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  fontSize: 18,
  height: 40,
  px: 3,
  color: "#24582A",
  bgcolor: "transparent",
  "&:hover": {
    bgcolor: "#D4E9CF",
  },
};

export const baseMenu = {
  paper: {
    width: 240,
    mt: 1,
    boxShadow: 3,
    borderRadius: 1,
    maxHeight: 165,
    overflowY: "auto",
    backgroundColor: "#FFFAF1",
    border: "1px solid #D4E9CF",
  },
  menuItem: {
    px: 1.5,
    py: 1,
    display: "flex",
    alignItems: "center",
    cursor: "default",
  },
  checkbox: {
    p: 0.5,
    color: "#24582A",
    "&.Mui-checked": {
      color: "#17371A",
    },
  },
  typography: (isChecked) => ({
    fontFamily:
      '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    fontSize: 16,
    ml: 1,
    color: isChecked ? "#24582A" : "#052812",
    fontWeight: isChecked ? 600 : 400,
    userSelect: "none",
  }),
};

export const sectionBox = {
  backgroundColor: "#D4E9CF",
  border: "4px solid #24582A",
  width: "95vw",

  p: 2,
  position: "relative",
  overflow: "visible",
};
